import React from 'react';
import './Blog.css';

const SubBlogs = ({ cards, onCardClick }) => {
	const goToTopBtn = () => {
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
	};
	return (
		<div className='sub_blog_container p-4'>
			<h4 className='mb-3'>Releated Blog</h4>
			{cards.map((card) => (
				<div
					key={card.id}
					className='card mb-3 mb-lg-3 mb-sm-3 mb-md-3'
					onClick={() => {
						onCardClick(card);
						goToTopBtn();
					}}
				>
					<img src={card.image} alt='subBlogs_images' class='card-img-top' />
					<hr style={{ width: '80%', margin: '10px auto' }} />
					<h4 className='mx-3'>{card.title}</h4>
					<h6 className='mx-3'>{card.subtitle}</h6>
				</div>
			))}
		</div>
	);
};

export default SubBlogs;
